import { fromJS } from 'immutable';
import UserActions from '../actions/UserActions';

const { UPDATE_STATUS } = UserActions.TYPES;

export const DEFAULT_STATE = fromJS({
    isLoggedIn: false,
    loading: false,
    accountInfo: null,
    enterpriseAccount: null,
    hasEsportEntitlement: false
});

export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case UPDATE_STATUS: {
            newState = newState.updateIn(['hasEsportEntitlement'], () => true);
            return newState;
        }
        default:
            return newState;
    }
}
